import { render, staticRenderFns } from "./project-group.component.vue?vue&type=template&id=7567070a&scoped=true&"
import script from "./project-group.component.vue?vue&type=script&lang=js&"
export * from "./project-group.component.vue?vue&type=script&lang=js&"
import style0 from "./project-group.component.vue?vue&type=style&index=0&id=7567070a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567070a",
  null
  
)

export default component.exports